import React, {Component} from 'react';
import HomePage from './pages/HomePage';
import {BrowserRouter, Link, NavLink, Route, Switch} from 'react-router-dom'
import classNames from 'classnames';
import {connect} from "react-redux";
import {fetchPageIfNeeded, fetchSite, fetchWorksIfNeeded} from "./redux/actions";
import {routes} from "./config";
import {Helmet} from 'react-helmet';
import {metaImages, metaTitles} from "./website-gridhaus/meta";
import ScrollToTop from "./website-gridhaus/ScrollToTop";
import 'aos/dist/aos.css';
import ServicesPage from "./pages/ServicesPage";
import TeamPage from "./pages/TeamPage";
import ContactPage from "./pages/ContactPage";
import WorkPage from "./pages/WorkPage";
import WorkDetailPage from "./pages/WorkDetailPage";
import Loader from "./parts/Loader";
import logo from './assets/images/gridhaus_logo.svg';
import logo_alt from './assets/images/gridhaus_logo_white.svg';
import AOS from 'aos/dist/aos';
import NotFoundPage from "./pages/NotFoundPage";
import BlogPage from "./pages/BlogPage";
import ArticlePage from "./pages/ArticlePage";
import Preview from "./pages/Preview";
import {withStyles} from '@material-ui/core/styles';
import Container from "./parts/Container";
import OptOutPage from "./pages/OptOutPage";
import OptInPage from "./pages/OptInPage";
import SubscribePopup from "./parts/SubscribePopup";
import Footer from "./parts/Footer";


const styles = (theme) => ({
  error: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  },
  errorMessage: {
    ...theme.typography.hg54r(theme),
    color: theme.palette.primary.main,
    marginBottom: theme.spacing.unit,
  },
  errorBrief: {
    ...theme.typography.hg36r(theme),
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNavActive: null,
      navBarListening: false,
    };
    this.toggleMobileNav = this.toggleMobileNav.bind(this);
    this.closeMobileNav = this.closeMobileNav.bind(this);
    this.lastOffset = 0;
  }

  componentDidMount() {
    AOS.init({
      offset: 150,
    });
    window.suppressSubscribePopup = !!window.localStorage.getItem('subscribed');
  }

  componentWillMount() {
    this.props.fetchSite();

    // Preload all the first level pages
    const pages = [
      'home_page',
      'services_page',
      'work_page',
      'team_page',
      'contact_page',
      'blog_page',
    ];
    pages.map(page => {
      this.props.dispatch(fetchPageIfNeeded(page));
    });

    this.props.dispatch(fetchWorksIfNeeded());
  }

  componentDidUpdate() {
    if (this.props.site && !this.state.navBarListening) {
      this.setState({
        navBarListening: true
      });
      window.addEventListener('scroll', this.updateNavBar, false);
      this.updateNavBar();
    }
  }

  toggleMobileNav() {
    this.setState({
      mobileNavActive: !this.state.mobileNavActive
    })
  }

  closeMobileNav() {
    this.setState({
      mobileNavActive: false
    })
  }

  updateNavBar() {
    const navBar = document.getElementById('nav-bar');
    const offset = window.pageYOffset || document.documentElement.scrollTop;
    if (offset > this.lastOffset) {
      // downscroll code
      if (offset > (navBar.clientHeight) && !navBar.classList.contains('locked')) {
        navBar.classList.add('hidden');
      }
    } else {
      // upscroll code
      navBar.classList.remove('hidden');
    }
    this.lastOffset = offset;

    if (offset > 0) {
      navBar.classList.add('hovering');
    } else {
      navBar.classList.remove('hovering');
    }
  }

  render() {
    const data = (this.props.site) ? this.props.site.data : null;
    const {isError, classes, isFetching} = this.props;


    return (
      <div className={'App'}>
        <Loader loaded={!isFetching}/>
        {(isError) && (
          <div className={classes.error}>
            <Container>
              <div className={classes.errorMessage}>
                There was an error.
              </div>
              <div className={classes.errorBrief}>
                Please reload your browser or try another Internet connection.
              </div>
            </Container>
          </div>
        )}
        {(data) && (
          <BrowserRouter>
            <React.Fragment>
              <Helmet>
                <title>{data.title}</title>
                <meta property="og:url"
                      content={window.location.protocol + '//' + window.location.hostname + window.location.pathname}/>
                {metaTitles(data.title)}
                {metaImages(data.logo.url)}
              </Helmet>
              <header className="nav-bar" id="nav-bar">
                <div className="container">
                  <div className={'logo'}>
                    <Link to={routes.home} onClick={this.closeMobileNav}>
                      <img className={'primary'} src={logo} alt="Gridhaus logo"/>
                      <img className={'alternate'} src={logo_alt} alt="Gridhaus logo"/>
                    </Link>
                  </div>
                  <div
                    className={classNames('nav-menu-container', {'is-active': this.state.mobileNavActive})}>
                    <div className={'logo'}>
                      <Link to={routes.home} onClick={this.closeMobileNav}>
                        <img src={logo} alt=""/>
                      </Link>
                    </div>
                    <nav className="nav-menu">
                      <ul>
                        {/*<li>*/}
                        {/*<NavLink exact activeClassName={'active'} to={routes.home}*/}
                        {/*onClick={this.closeMobileNav}>Home</NavLink>*/}
                        {/*</li>*/}
                        <li>
                          <NavLink exact activeClassName={'active'} to={routes.work}
                                   onClick={this.closeMobileNav}>Work</NavLink>
                        </li>
                        <li>
                          <NavLink exact activeClassName={'active'} to={routes.services}
                                   onClick={this.closeMobileNav}>Services</NavLink>
                        </li>
                        <li>
                          <NavLink exact activeClassName={'active'} to={routes.team}
                                   onClick={this.closeMobileNav}>Team</NavLink>
                        </li>
                        <li>
                          <NavLink exact activeClassName={'active'} to={routes.blog}
                                   onClick={this.closeMobileNav}>Blog</NavLink>
                        </li>
                        <li>
                          <NavLink exact activeClassName={'active'} to={routes.contact}
                                   onClick={this.closeMobileNav}>Contact</NavLink>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <button
                    className={classNames("nav-menu-button", {'is-active': this.state.mobileNavActive})}
                    onClick={this.toggleMobileNav}>
                    <div className={'container'}>
                      <div className={'line line-1'}/>
                      <div className={'line line-2'}/>
                      <div className={'line line-3'}/>
                      <div className={'line line-4'}/>
                    </div>
                  </button>
                </div>
              </header>
              <main className='page-content'>
                <ScrollToTop delay={0}>
                  <div className={'overlay'}/>
                  <Switch>
                    <Route exact path={routes.home} component={HomePage}/>
                    <Route exact path={routes.services} component={ServicesPage}/>
                    <Route exact path={routes.team} component={TeamPage}/>
                    <Route exact path={routes.work} component={WorkPage}/>
                    <Route path={routes.work + '/:uid'} component={WorkDetailPage}/>
                    <Route exact path={routes.contact} component={ContactPage}/>
                    <Route exact path={routes.blog} component={BlogPage}/>
                    <Route path={routes.blog + '/:uid'} component={ArticlePage}/>
                    <Route path={routes.preview} component={Preview}/>
                    <Route path={routes.optOut} component={OptOutPage}/>
                    <Route path={routes.optIn} component={OptInPage}/>
                    <Route component={NotFoundPage} status={404}/>
                  </Switch>
                </ScrollToTop>
              </main>
              <Footer data={data}/>
              <SubscribePopup open={this.props.subscribePopupOpen}/>
            </React.Fragment>
          </BrowserRouter>
        )}
      </div>
    );
  }
}

const
  mapStateToProps = state => {
    return {
      site: state.site && state.site.item,
      isError: state.site && state.site.isError,
      isFetching: state.site && state.site.isFetching,
      subscribePopupOpen: state.subscribePopup.open,
    };
  };

const
  mapDispatchToProps = dispatch => {
    return {
      fetchSite: () => {
        dispatch(fetchSite());
      },
      dispatch
    };
  };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));


// WEBPACK FOOTER //
// ./src/App.js